/**
 * Class representing the ripple effect functionality.
 */
export default class Ripple {
  /**
   * Initializes the Ripple class and sets up the event listener.
   */
  constructor() {
    document.addEventListener("click", this.handleClick.bind(this));
  }

  /**
   * Handles the click event and applies the ripple effect.
   * @param {MouseEvent} event - The mouse event triggered by the click.
   */
  handleClick(event: MouseEvent): void {
    // Find the closest element with the class 'fe-ripple'
    const target: HTMLElement | null = (event.target as HTMLElement).closest(".fe-ripple");

    // If a target element is found, set the ripple offset
    if (target) {
      this.setRippleOffset(event, target);
    }
  }

  /**
   * Sets the ripple offset CSS variables based on the click event position.
   * @param {MouseEvent} event - The mouse event triggered by the click.
   * @param {HTMLElement} target - The target element where the ripple effect is applied.
   */
  setRippleOffset(event: MouseEvent, target: HTMLElement): void {
    // Get the bounding rectangle of the target element
    const rect: DOMRect = target.getBoundingClientRect();
        
    // Calculate the click position relative to the center of the target element
    const x: number = event.clientX - rect.left - rect.width / 2;
    const y: number = event.clientY - rect.top - rect.height / 2;
        
    // Set the CSS variables for the ripple offset
    target.style.setProperty("--fe-ripple-offset-x", `${x}px`);
    target.style.setProperty("--fe-ripple-offset-y", `${y}px`);
  }
}

